import { BillTo, ServiceLocation } from '@user/store/entityLocations'
import { produce } from 'immer'
import { MappedServiceLocattionUpdateResult, State } from '../typings'

export type UpdateServiceLocationAction = {
  type: 'updateServiceLocation'
  payload: MappedServiceLocattionUpdateResult
}

type UpdateServiceLocationActionCreator = (
  payload: UpdateServiceLocationAction['payload'],
) => UpdateServiceLocationAction

export const updateServiceLocation = produce<
  State,
  [UpdateServiceLocationAction['payload']]
>((draft, payload) => {
  const { id, isBillingLocation, updateBillingLocation } = payload

  if (isBillingLocation || updateBillingLocation) {
    if (draft.primaryServiceLocation) {
      const newBillTo: BillTo = {
        ...draft.primaryServiceLocation?.billTo,

        ...payload,
        id: draft.primaryServiceLocation.billTo.id,
      }
      draft.primaryServiceLocation.billTo = { ...newBillTo }
      draft.primaryServiceLocation.billToId = newBillTo.id
    }
  }
  if (!isBillingLocation) {
    if (draft.selectedServiceLocations.has(id.toString())) {
      const location = draft.selectedServiceLocations.get(id.toString())
      if (location) {
        const newLocation: ServiceLocation = {
          ...location,
          altPhone: payload.altPhone,
          altPhoneExt: payload.altPhoneExt,
          company: payload.company,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          phone: payload.phone,
          phoneExt: payload.phoneExt,
        }
        draft.selectedServiceLocations.set(id.toString(), newLocation)
      }
    }
    const index = draft.serviceLocations.findIndex((x) => x.id == id.toString())
    if (index > -1) {
      const location = { ...draft.serviceLocations[index] }
      const newLocation: ServiceLocation = {
        ...location,
        altPhone: payload.altPhone,
        altPhoneExt: payload.altPhoneExt,
        company: payload.company,
        email: payload.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        phone: payload.phone,
        phoneExt: payload.phoneExt,
      }
      draft.serviceLocations = [...draft.serviceLocations].map((t) => {
        if (t.id === newLocation.id) return newLocation
        else return t
      })
    }
  }
})

export const updateServiceLocationActionCreator: UpdateServiceLocationActionCreator =
  (payload) => ({
    type: 'updateServiceLocation',
    payload,
  })
